export default {
    toolsProfit:{
        calculate: 'Calculate',
        CustomerDetails: 'Customer Details',
        Storage: 'Daily Storage',
        PostageMargin: 'Postage Margin',
        WeeklyOrder: 'Weekly Order',
        ProfitComparison: 'Profit Comparison',
        ComparisonItem: 'Comparison Item',
        SampleCompany: 'Sample Company',
        PotentialCustomer: 'Comparative Companies',
        ChargeItems: 'Charge Items',
        SlendierPrice: 'Slendier Price',
        Quote: 'Quote',
        industry: 'Industry',
        ClientTemplate: 'Client Template',
        BorC: 'B or C',
        dataRange: 'Data Range',
        DataModel: 'Data Model',
        PotentialUserProfitPrediction: 'Potential User Profit Prediction',
        ExistingCustomerProfitAdjustment: 'Existing Customer Profit Adjustment',
        timePeriod: 'Time Period'
    }
}